import { faCircle } from '@awesome.me/kit-5de77b2c02/icons/classic/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from 'classnames'
import { EffectsProps } from './types'

import styles from './effects.module.css'

const FlashingCircleAfter = ({ content, active, className }: EffectsProps) => {
  return (
    <span className={cx(className, styles.effectSvgContainer)}>
      {content}
      {active && <FontAwesomeIcon icon={faCircle} beatFade size="2xs" />}
    </span>
  )
}

export default FlashingCircleAfter
